import { render, staticRenderFns } from "./CargoHandlingDialog.vue?vue&type=template&id=ab56eb18&"
import script from "./CargoHandlingDialog.vue?vue&type=script&lang=js&"
export * from "./CargoHandlingDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports